import { render, staticRenderFns } from "./PromotionValidationTypesField.vue?vue&type=template&id=5eead375"
import script from "./PromotionValidationTypesField.vue?vue&type=script&lang=js"
export * from "./PromotionValidationTypesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports